/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect } from 'react';
import { useParams } from 'umi';
import { PAGE_CONFIG } from './pageConfig';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import './index.scss';
import { StudioContext } from '../context';

const gtdrAssessment = () => {
  const { studioId, gameCode } = useParams() || {} as any;
  const { menuPermission } = useContext(StudioContext);

  useEffect(() => {
    // 设置全局样式
    const element = document.querySelector('.dbh-studio-context');
    if (element && menuPermission === true) {
      (element as HTMLElement).style.backgroundColor = '#ebecf1';
    }
    return () => {
      // 去掉全局样式
      if (element) {
        (element as HTMLElement).style.backgroundColor = '#fff';
      }
    };
  }, [menuPermission]);

  return (
    <CommonPageRender
      className="dbh-studio-gtdrAssessment"
      reqParams={'/gtdrAssessment'}
      key={gameCode + studioId}
      frameType='game'
      // @ts-ignore
      pageConfigInit={PAGE_CONFIG}
      api={PAGE_CONFIG_API}
    />
  );
};

export default gtdrAssessment;
